<template>
    <div>
        <div v-if="isNoopVal">--</div>
        <div v-else>
            <image-item class="image" :src="value[0]" alt="img" />
        </div>
    </div>
</template>

<script>
import ImageItem from '../ImageItem';

export default {
    name: 'formatImages',
    components: {
        ImageItem
    },
    props: {
        value: {},
        scope: {},
    },
    computed: {
        isNoopVal() {
            return ['', undefined, null].includes(this.value);
        },
    },
    data() {
        return {
            currentIndex: 0,
            visable: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.image {
    width: 100%;
}
</style>
